import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment";
import { useSelector } from "react-redux";
import CustomLoader from "./CustomLoader";
import HoverTooltip from "./hoverOverlay/HoverTooltip";
const LastUpdatedInfo = ({ updatedAt, onRefresh, disabled = false, loading = false, moduleName, showIcon, statusText, disabledReason, showAgo = false, iconOnly = false }) => {
    const [spin, setSpin] = useState(false);
    const permissions = useSelector((state) => state.auth.permissions);
    const canShowRefreshIcon = useMemo(() => {
        if (showIcon === false)
            return false;
        if (showIcon === true)
            return true;
        if (!moduleName)
            return false;
        return permissions?.[moduleName]?.refresh !== false;
    }, [showIcon, permissions, moduleName]);
    const date = useMemo(() => {
        if (!updatedAt)
            return null;
        const m = moment(updatedAt);
        return m.isValid() ? m : null;
    }, [updatedAt]);
    const datePart = date ? date.format("MMM DD, YYYY") : "--";
    const timePart = date ? date.format("hh:mm A") : "--";
    const ago = date ? date.fromNow(true) : "";
    const isDisabled = disabled || loading || !!disabledReason;
    const handleClick = () => {
        if (spin || isDisabled)
            return;
        setSpin(true);
        setTimeout(() => setSpin(false), 900);
        onRefresh?.();
    };
    const isSpinning = spin || loading;
    return (_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: "6px", bgcolor: "#ffffff", borderRadius: "16px" }, children: [canShowRefreshIcon && (_jsx(HoverTooltip, { title: isDisabled ? disabledReason || "" : "", disableHoverListener: !isDisabled || !disabledReason, children: _jsx(Box, { onClick: handleClick, sx: {
                        width: 38,
                        height: 38,
                        borderRadius: "14px",
                        bgcolor: "#f3f4f6",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        flexShrink: 0,
                        opacity: isDisabled ? 0.6 : 1,
                    }, children: loading ? (_jsx(CustomLoader, { size: 18, color: "inherit", sx: { opacity: 0.7 } })) : (_jsx("img", { src: "/assets/refresh.svg", alt: "refresh", style: {
                            width: 18,
                            height: 18,
                            opacity: 0.7,
                            transition: "transform 0.9s ease",
                            transform: isSpinning ? "rotate(360deg)" : "none",
                        } })) }) })), !iconOnly && (_jsxs(Box, { children: [_jsx(Typography, { sx: { fontSize: '13px !important', fontWeight: 500, color: "#6b7280", lineHeight: 1.2 }, className: "all-Font-Sizes", children: "Last updated" }), date ? (_jsxs(Typography, { sx: { fontSize: '13px !important', lineHeight: 1.3, color: "#111827" }, className: "all-Font-Sizes", children: [_jsx(Box, { component: "span", sx: { fontWeight: 500 }, children: datePart }), _jsx(Box, { component: "span", sx: { mx: 0.5, color: "#6b7280" }, children: "at" }), _jsx(Box, { component: "span", sx: { fontWeight: 500 }, children: timePart }), showAgo && (_jsxs(Box, { component: "span", sx: { ml: 1, color: "#6b7280" }, children: ["(", ago, " ago)"] }))] })) : (_jsx(Typography, { sx: { fontSize: '13px !important', lineHeight: 1.3, color: "#111827" }, className: "all-Font-Sizes", children: "Last sync date not available." }))] }))] }));
};
export default LastUpdatedInfo;
